import { render, staticRenderFns } from "./PurchaseInvoiceDownload.vue?vue&type=template&id=b4052a20&"
import script from "./PurchaseInvoiceDownload.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoiceDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports